// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__Yr5AL","inner":"style_inner__0vbTk","slide-in-bottom":"style_slide-in-bottom__l-Ou0"};